import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import download_url from "../../../files/actions/download_url"
import navigate from "../../navigate"

export default CreateRenderFunction({
  data: {
    imposition_url: "",
  },
  mounted() {
    download_url(this.imposition_url.replace(/\/json\//g, "/pdf/"))
    navigate()
  },
  render() {
    return null
  },
})
